// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { settingsFailedToLoadMessage } from 'redux/modules/notifications/helpers'
import { fetchApplicationSettings } from 'helpers/api'
import { addApplicationSettings } from '../actions'

const fetchAndAddApplicationSettings = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      try {
        const { entity } = await fetchApplicationSettings()
        dispatch(addApplicationSettings(entity))
      } catch (err) {
        console.warn(err)
        dispatch(settingsFailedToLoadMessage('Application', err))
      }
    })
  )
)

export default fetchAndAddApplicationSettings
